export enum DateInputStyle {
	dob = 'dob',
}

export enum MCInputStyle {
	radio = 'radio',
	horizontalRadio = 'horizontalRadio', // introduced for program form
	dropdown = 'dropdown',
	dropdownInlineOthers = 'dropdownInlineOthers',
	autocomplete = 'autocomplete',
}

export enum MSELStyle {
	checkbox = 'checkbox',
	ranking = 'ranking',
	dropdown = 'dropdown',
	chipDropdown = 'chipDropdown', // introduced for program form
	chipDropdownChipView = 'chipDropdownChipView', // introduced for mtr evaluation form
}

export enum StaticTextStyle {
	info = 'info',
	reminder = 'reminder',
	paragraph = 'paragraph',
	title = 'title',
	subheader = 'subheader',
}

export enum StaticLinkStyle {
	info = 'info',
}

export enum ImageInputStyle {
	showDownloadAll = 'showDownloadAll',
}
